<script>
import { mapActions, mapState } from 'vuex'
import {
  favoriteGeneralAddResource,
  favoriteGeneralRemoveResource,
} from '@api/like.general.service'

export default {
  name: 'AddToFavoritesGeneral',

  props: {
    id: {
      type: [String, Number],
    },
    target: {
      type: String,
      default: '',
    },
    isLiked: {
      type: Boolean,
    },
  },

  data() {
    return {
      isLikedLocal: this.isLiked || false,
    }
  },

  computed: {
    ...mapState('like', [
      'lastAction',
    ]),
  },

  watch: {
    lastAction: {
      deep: true,
      immediate: true,
      handler(nval) {
        if (this.target !== nval.target) return

        if (this.id === nval.added) {
          this.isLikedLocal = true
        }

        if (this.id === nval.removed) {
          this.isLikedLocal = false
        }
      },
    },
  },

  methods: {
    ...mapActions('like', [
      'setAddedId',
      'setRemovedId',
      'setTarget',
    ]),

    add() {
      const data = { objects: [{ element: { type: this.target, id: this.id } }] }

      favoriteGeneralAddResource.execute({}, data).then(() => {
        this.setAddedId(this.id)
        this.setRemovedId(null)
        this.setTarget(this.target)
      })
    },

    async remove() {
      const data = { objects: [{ element: { type: this.target, id: this.id } }] }

      favoriteGeneralRemoveResource.execute({}, data).then(() => {
        this.setRemovedId(this.id)
        this.setAddedId(null)
        this.setTarget(this.target)

        this.$emit('hook:remove', true)
      })
    },
  },

  render(h) {
    return this.$scopedSlots.default({
      add: () => this.add(),
      remove: () => this.remove(),
      is_added: this.isLikedLocal,
    })
  },
}
</script>
